import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Wand2 } from "lucide-react";
import { generatePassword } from "@/lib/password";

export const DRIVER_PW_MIN = 5;

export const PasswordField = ({ value, onChange, label = "Password", min = 8 }) => (
  <div>
    <Label htmlFor="driver-password" className="text-sm">{label}</Label>
    <div className="mt-1.5 flex flex-col sm:flex-row gap-2">
      <Input
        id="driver-password"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={`At least ${min} characters`}
        className="h-11 font-mono"
        autoComplete="new-password"
        data-testid="driver-password-input"
      />
      <Button
        type="button"
        variant="outline"
        className="h-11 shrink-0"
        onClick={() => onChange(generatePassword())}
        data-testid="generate-password-btn"
      >
        <Wand2 className="w-4 h-4 mr-1.5" /> Generate password
      </Button>
    </div>
    <p className="mt-1.5 text-xs text-slate-500">Use at least {min} characters, or tap Generate.</p>
  </div>
);
